// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import cx from 'classnames';
import Spinner from '../Spinner';
import styles from './SpinnerButton.module.scss';

/** @typedef {{
  loading?: boolean,
} & React.ButtonHTMLAttributes } SpinnerButtonPropsType */

/** @type { React.ValidationMap<SpinnerButtonPropsType> } */
const propTypes = {
  loading: PropTypes.bool.isRequired,
};

/** @type { Partial<SpinnerButtonPropsType> } */
const defaultProps = {
  loading: false,
};

/** @type { StatelessComponent<SpinnerButtonPropsType> } */
const SpinnerButton = ({ loading, ...rest }) => (
  <button disabled={rest.disabled || loading} {...rest}>
    <div className={cx(styles.button_inner, { loading })}>
      {loading && (
        <div className={styles.spinner_container}>
          <Spinner />
        </div>
      )}
      <div>{rest.children}</div>
    </div>
  </button>
);

SpinnerButton.displayName = 'SpinnerButton';
SpinnerButton.propTypes = propTypes;
SpinnerButton.defaultProps = defaultProps;

export default SpinnerButton;
